import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-cover',
  templateUrl: './hero-cover.component.html',
  styleUrls: ['./hero-cover.component.css']
})
export class HeroCoverComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
